export const LESSON_TOPIC_MAP = {
  'arithmetic-foundations': {
    label: 'Arithmetic Foundations',
    topicIds: ['number_properties', 'ratios_percents', 'unit_conversions'],
    subconcepts: [
      'divisibility',
      'parity',
      'percents',
      'ratios',
      'unit_conversion',
    ],
  },
  'math-translation': {
    label: 'Math Translation',
    topicIds: ['general_word_problems', 'algebra', 'rates'],
    subconcepts: [
      'translation',
      'word_problems_algebra',
      'linear_equations',
      'unit_rate',
      'work',
    ],
  },
  'math-shortcuts': {
    label: 'Math Shortcuts',
    topicIds: ['number_properties', 'ratios_percents', 'general_word_problems'],
    subconcepts: [
      'arithmetic_translation',
      'percents',
      'divisibility',
      'units_digit',
    ],
  },
  integers: {
    label: 'Number Properties',
    topicIds: ['number_properties'],
    subconcepts: [
      'divisibility',
      'factors',
      'gcd_lcm',
      'parity',
      'primes',
      'remainders',
    ],
  },
  sequences: {
    label: 'Sequences',
    topicIds: ['sequences'],
    subconcepts: [
      'arithmetic_sequences',
      'geometric_sequences',
      'patterns',
      'recursive_sequences',
      'series_sums',
    ],
  },
  'percentage-ratio': {
    label: 'Ratios + Percents',
    topicIds: ['ratios_percents', 'general_word_problems'],
    subconcepts: ['ratios', 'percents', 'percent_change', 'mixture'],
  },
  exponents: {
    label: 'Exponents & Roots',
    topicIds: ['exponents', 'roots'],
    subconcepts: [
      'exponents',
      'fractional_exponents',
      'negative_exponents',
      'radicals',
    ],
  },
  algebra: {
    label: 'Algebra',
    topicIds: ['algebra', 'linear_quadratic', 'inequalities', 'absolute_value'],
    subconcepts: [
      'linear_equations',
      'quadratic_equations',
      'systems_of_equations',
      'inequalities',
    ],
  },
  'absolute-value': {
    label: 'Absolute Value',
    topicIds: ['absolute_value'],
    subconcepts: [
      'distance',
      'equations',
      'inequalities',
      'evaluate',
      'properties',
    ],
  },
  functions: {
    label: 'Functions',
    topicIds: ['functions'],
    subconcepts: [
      'function_evaluation',
      'composition',
      'domain_range',
      'graphs',
    ],
  },
  sets: {
    label: 'Overlapping Sets',
    topicIds: ['overlapping_sets'],
    subconcepts: ['overlapping_sets', 'union_intersection', 'venn_diagrams'],
  },
  probabilities: {
    label: 'Probability + Counting',
    topicIds: ['probability', 'combinations_permutations'],
    subconcepts: [
      'probability',
      'conditional_probability',
      'combinations',
      'permutations',
    ],
  },
  'work-rate': {
    label: 'Work Problems',
    topicIds: ['work_problems', 'rates'],
    subconcepts: ['single_worker', 'combined_rate', 'work_rate', 'work_units'],
  },
  'distance-rate': {
    label: 'Rates',
    topicIds: ['rates', 'unit_conversions'],
    subconcepts: [
      'd=rt',
      'average_speed',
      'relative_motion',
      'unit_conversion',
    ],
  },
  'coordinate-geometry': {
    label: 'Coordinate Geometry',
    topicIds: ['coordinate_geometry'],
    subconcepts: ['distance', 'graphs', 'lines', 'midpoint', 'slope'],
  },
  circles: {
    label: 'Circles',
    topicIds: ['geometry'],
    subconcepts: ['circles'],
  },
  triangles: {
    label: 'Triangles',
    topicIds: ['geometry'],
    subconcepts: ['triangles', 'angles', 'area_perimeter'],
  },
  quadrilaterals: {
    label: 'Quadrilaterals',
    topicIds: ['geometry'],
    subconcepts: ['polygons', 'area_perimeter'],
    practiceSubconcepts: [],
  },
  polygons: {
    label: 'Polygons',
    topicIds: ['geometry'],
    subconcepts: ['polygons', 'angles', 'area_perimeter'],
    practiceSubconcepts: [],
  },
  'three-dimensional-figures': {
    label: '3D Geometry',
    topicIds: ['geometry'],
    subconcepts: ['volume'],
    practiceSubconcepts: [],
  },
  volumes: {
    label: 'Volume + Surface Area',
    topicIds: ['geometry'],
    subconcepts: ['volume'],
    practiceSubconcepts: [],
  },
  statistics: {
    label: 'Statistics + Data Analysis',
    topicIds: ['statistics', 'data_analysis_problems'],
    subconcepts: [
      'mean',
      'median',
      'range',
      'standard_deviation',
      'quartiles',
      'percentiles',
    ],
  },
  graphs: {
    label: 'Graphs + Data Interpretation',
    topicIds: ['data_interpretation_questions', 'statistics'],
    subconcepts: [
      'bar_charts',
      'line_graphs',
      'tables',
      'scatter_plots',
      'box_plots',
    ],
  },
};

export const getLessonTopicConfig = (lessonId) =>
  LESSON_TOPIC_MAP[lessonId] || null;

export const getLessonTopicIds = (lessonId) =>
  getLessonTopicConfig(lessonId)?.topicIds || [];

export const getPrimaryLessonTopicId = (lessonId) =>
  getLessonTopicIds(lessonId)[0] || null;
